import StopPaymentConfirmPage, { getDefaultPageData } from "components/pages/StopPaymentConfirmPage";
import { BCMSStateManagerCRUD, useBCMSContext, BCMSRecord, useModel } from "bcms-react";
import Classes from "model";

export default function CaptureStopPaymentConfirm(props) {
    const globalController = useBCMSContext();
    const { branding } = useModel();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData(branding.options, globalController))
        .update([ "payment", "account" ], "0")
        .update([ "payment", "checkNumber" ], "123")
        .update([ "payment", "amount" ], "100")
        .update([ "payment", "reason" ], "Check Issued for Incorrect Amount")
        .submit();

    return <StopPaymentConfirmPage data={ data } />
}